/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RevokeClusterInviteRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/**
 * OK
 */
export type RevokeClusterInviteResponseBody = {
  message: string;
};

/** @internal */
export const RevokeClusterInviteRequest$inboundSchema: z.ZodType<
  RevokeClusterInviteRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type RevokeClusterInviteRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const RevokeClusterInviteRequest$outboundSchema: z.ZodType<
  RevokeClusterInviteRequest$Outbound,
  z.ZodTypeDef,
  RevokeClusterInviteRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function revokeClusterInviteRequestToJSON(
  revokeClusterInviteRequest: RevokeClusterInviteRequest,
): string {
  return JSON.stringify(
    RevokeClusterInviteRequest$outboundSchema.parse(revokeClusterInviteRequest),
  );
}
export function revokeClusterInviteRequestFromJSON(
  jsonString: string,
): SafeParseResult<RevokeClusterInviteRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RevokeClusterInviteRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RevokeClusterInviteRequest' from JSON`,
  );
}

/** @internal */
export const RevokeClusterInviteResponseBody$inboundSchema: z.ZodType<
  RevokeClusterInviteResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
});
/** @internal */
export type RevokeClusterInviteResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RevokeClusterInviteResponseBody$outboundSchema: z.ZodType<
  RevokeClusterInviteResponseBody$Outbound,
  z.ZodTypeDef,
  RevokeClusterInviteResponseBody
> = z.object({
  message: z.string(),
});

export function revokeClusterInviteResponseBodyToJSON(
  revokeClusterInviteResponseBody: RevokeClusterInviteResponseBody,
): string {
  return JSON.stringify(
    RevokeClusterInviteResponseBody$outboundSchema.parse(
      revokeClusterInviteResponseBody,
    ),
  );
}
export function revokeClusterInviteResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<RevokeClusterInviteResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RevokeClusterInviteResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RevokeClusterInviteResponseBody' from JSON`,
  );
}
